import { createSlice } from "@reduxjs/toolkit";

export const companyIdSlice = createSlice({
    name:'companyid',
    initialState:{
        value:'',
    },
    reducers:{
        updateCompanyId:(state, action)=>{
             state.value = action.payload;
           
        }
    }
})

export const selectCid = (state)=>state.companyid.value

export const { updateCompanyId } = companyIdSlice.actions

export default companyIdSlice.reducer